import { Formik } from "formik";
import * as React from "react";
import { useIntl } from "react-intl";
import { Routine } from "redux-saga-routines";
import {Action, ActionFunctionAny} from "redux-actions";
import SettingsHeader from "../General/header";
import { StyledForm } from "../General/Tabs/styled";
import { SettingsLayout, Section, FieldGrid } from "./settingsLayout";
import { DeviceComponents, getDeviceSettings, excludeComponentWrapper } from "../tabDefinition";
import Footer from "./Footer";
import {SettingEnum, SettingEnum as ComponentSettingEnum} from "../settingEnum";
import Toggle from "@Elements/Switch";
import {Capabilities} from "@Safemate/Settings/Store/types";
import {DeviceHardwareEnum} from "@Safemate/DeviceHardwareEnum";

interface SettingTabProps{
  dehaId: number;
  deviId: number;
  settings: any;
  save: Routine<ActionFunctionAny<Action<any>>>;
  settingEnum: ComponentSettingEnum;
  capabilities: Capabilities ;
  isPrivate: boolean;
  beta: boolean;
  header: {
    title: string;
    tooltip?: string;
    tooltipTitle?: string;
    children?: JSX.Element;
    toggle?: boolean;
    toggleValue?: string[];
  }
}

const SettingTab = ({ dehaId, deviId, settings, save, settingEnum, header, isPrivate, beta, capabilities }: SettingTabProps) => {

  const { formatMessage } = useIntl();
  const settingComponents: Map<SettingEnum, JSX.Element[]> = DeviceComponents.has(dehaId) ? DeviceComponents.get(dehaId)! : DeviceComponents.get(DeviceHardwareEnum.DEFAULT)!;

  const components: Map<ComponentSettingEnum, JSX.Element[]> = getDeviceSettings(dehaId, capabilities, isPrivate, beta, settingComponents);

  const excludeWrapper = excludeComponentWrapper(settingEnum, dehaId);

  return(
    <Formik
      onSubmit={(values) => {
        save({
          deviceId: deviId,
          settings: values
        })
      }}
      initialValues={settings}
      enableReinitialize
    >
    {({values, setFieldValue}) => 
      <StyledForm>
        <SettingsHeader 
          title={formatMessage({id: header.title, defaultMessage: header.title})}
          tooltip={header.tooltip}
          tooltipTitle={{
            id: header.tooltipTitle,
            defaultMessage: header.tooltipTitle
          }}
        >
          <React.Fragment>
          {(header.toggleValue && header.toggle)  &&
            <Toggle
              checked={(() => {
                let value = values;
                for(let i = 0; i < header.toggleValue.length; i++){
                  value = value[header.toggleValue[i]];
                }
                return value;
              })()}
              onChange={(value: boolean) => setFieldValue(header.toggleValue.join("."), value)}
            />}
            {header.children}
          </React.Fragment>
        </SettingsHeader>
        <div>
          {excludeWrapper
            ? components.has(settingEnum)
              && components.get(settingEnum)?.map((comp, i) =>
                <React.Fragment key={i}>{comp}</React.Fragment>)
            : components.has(settingEnum)
              && <SettingsLayout>
                  <Section>
                    <FieldGrid>
                      {components.get(settingEnum)?.map((comp, i) =>
                        <div key={i}>{comp}</div>)}
                    </FieldGrid>
                  </Section>
                </SettingsLayout>}
        </div>
        <Footer
          settings={settings}
        />
      </StyledForm>}
    </Formik>
  )
}

export default SettingTab;
